<template>
  <div class="container">
    <PublicHeader :totalName="$t('finance').financeOrderList" />
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getFinanceOrderList" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`fiorder${dIndex}`">
          <div class="name">{{ dItem.name }}</div>
          <div class="time">{{ $t('finance').Subscriptiondate }}：{{ dItem.applyTime | getLocalTime }}<span @click="$router.push({ name: 'FinanceOrderInfo', query: { id: dItem.financingOrderId } })">{{ $t('finance').seeDetail }}</span></div>
          <div class="time" v-if="dItem.status==1">{{ $t('finance').duedate }}：{{ dItem.maturityTime | getLocalTime }}</div>
          <div class="time" v-if="dItem.status==3">{{ $t('finance').duedate }}：{{ $t('c2c').Completed }}</div>
          <div class="yieldInfo" v-if="dItem.status==1">
            <div class="txtss"><span>{{$t('finance').investment}}</span><span>{{$t('finance').EstimatedReturn}}</span></div>
            <div class="num"><span>{{ dItem.amount }} USDT</span><span>{{ (dItem.amount*dItem.yieldMin/100*dItem.yieldDays).toFixed(6).replace(/\.?0+$/, '') }} USDT</span></div>
          </div>
          <div class="yieldInfo" v-if="dItem.status==3">
            <div class="txtss"><span>{{$t('finance').investment}}</span><span>{{$t('finance').yieldmaturity}}</span></div>
            <div class="num"><span>{{ dItem.amount }} USDT</span><span>{{ dItem.revenueAmount }} USDT</span></div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    this.getFinanceOrderList()
  },
  methods: {
    // 获取理财订单记录
    async getFinanceOrderList() {
      if (this.isRun) return
      this.isRun = true
      const res = await orderApi.getFinanceOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 50px;
  padding-bottom: 30px;

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;

      span {
        padding: 12px 0;
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--text_color);
      }
    }
  }

  .listInfo {
    .item {
      padding: 15px;
      border-bottom: 1px solid var(--info_color);

      .name {
        font-size: 16px;
        color: var(--text_color);
      }

      .time {
        margin-top: 10px;
        font-size: 13px;
        color: var(--ntext_color);
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          padding: 5px 10px;
          border-radius: 15px;
          font-size: 10px;
          font-weight: normal;
          color: var(--background_color);
          background: var(--text_color);
        }
      }
      .yieldInfo {
        margin-top: 15px;
        background: var(--info_color);
        padding: 15px;
        border-radius: 5px;

        .txtss {
          font-size: 12px;
          color: var(--ntext_color);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .num {
          margin-top: 15px;
          font-size: 12px;
          color: var(--text_color);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }

  .orderInfo {
    padding: 20px 15px;

    .name {
      font-size: 18px;
      font-weight: bold;
      color: var(--text_color);
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        font-size: 13px;
        font-weight: normal;
      }
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: var(--background_color);
      background: var(--text_color);
    }

    .btns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .b1 {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--text_color);
        background: var(--info_color);
      }

      .b2 {
        margin-left: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
